import React from "react";
import "./sass/bopis-option.scss";
import PickupDetails from "../below-belt/pick-up-details";

function BopisOption({
  selected = true,
  select = () => {},
  details,
  fulfillmentDetails={},
}) {
  const {
    store,
    enabled,
    inventory,
    available,
    useNearby,
    nearbyStore,
  } = details ;
  let isPurchasableInLocalStoreInStock, isZeroStockInLocalStoreActive;
  ({
    isPurchasableInLocalStoreInStock,
    isZeroStockInLocalStoreActive
  } = fulfillmentDetails || false);
  const storeName = store ? store.storeName : "NOT LOCALIZED";
  const limitedStock =
    inventory.store
      ? inventory.store.isLimitedQuantity
      : "";

  const limitedStockInventoryRestricted = details.isInventoryRestricted && inventory.store.isLimitedQuantity && !details.isAlphaPromptRestricted;

  const nearbyStoreLimitedStock =
    inventory.nearbyStore
      ? inventory.nearbyStore.isLimitedQuantity
      : "";
  const localStoreStockQuantity =
    inventory.store
      ? inventory.store.quantity
      : "";

  let cardClasses =
    "pickupTile card card-container card-background ";
  cardClasses += selected ? "card-selected " : "card-unselected ";
  cardClasses += enabled ? "card-enabled " : "card-unselected ";

  const pickUpText =  fulfillmentDetails.showBopisCovidAlert ? <span className="dai_tileMessage">Available</span> : <span className="dai_tileMessage">Pickup</span>;
  const pickupDay =  fulfillmentDetails.showBopisCovidAlert ? '': 'Today';

  if (isPurchasableInLocalStoreInStock) {
    cardClasses.replace("card-enabled", "");
    return (
      <div className={cardClasses}>
        <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
          <div className="pickup-in-store__icon pick-up-false"/>
          <div className="tile-heading pickup-in-store__heading dai_tileHeading">
            In-Store Purchase
          </div>
          <div className="tile-message pickup-in-store__message dai_tileMessage">
            <span>Available</span>
          </div>
          <div className="dai_tilePrice pickup-in-store__message--purchase-in-store">
            <div>{storeName}</div>
            <div className="u__text--success ">
              <span className="u__bold" >{`${localStoreStockQuantity} `}</span>
              in stock
            </div>
          </div>
        </div>
      </div>
    );
  } else if (isZeroStockInLocalStoreActive) {
    cardClasses.replace("card-enabled", "");
    return (
      <div className={cardClasses}>
        <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
          <div className="pickup-in-store__icon pick-up-false"/>
          <div className="tile-heading pickup-in-store__heading dai_tileHeading">
            In-Store Purchase
          </div>
          <div className="tile-message pickup-in-store__message pickup-in-store__message--purchase-in-store dai_tileMessage">
            Visit your store to check availability
          </div>
        </div>
      </div>
    );
  } else if (available) {
    return (
        <div className={cardClasses} onClick={() => enabled && select("PICKUP")}>
          <div
              className={
                "pickup-in-store__wrapper " +
                (enabled ? "" : "pickup-in-store__wrapper--disabled")}
          >
            <div>
              <div
                  className={
                    "pickup-in-store__icon pick-up-" + (enabled ? "true" : "false")
                  }
              ></div>
              <div className="tile-heading pickup-in-store__heading dai_tileHeading">
                Store Pickup
              </div>
            </div>
            <div className="pickup-in-store__message-wrapper">
              <div className="tile-message pickup-in-store__message">
                <div className="" data-automation-id="fulfillmentMessageText">
                  {pickUpText}
                </div>
              </div>
              <div className="tile-date pickup-in-store__message pickup-in-store__message--bold">
              <span className="dai_tileDate">
                {pickupDay?pickupDay:"\u00a0"}
                {useNearby
                    ? " (" + nearbyStore.distance + " mi)"
                    : ""}
              </span>
              </div>
            </div>
          </div>
          <div className="u__center card-messaging-bottom card-messaging-price" >
          <div className="u__text--success dai_tilePrice">
            {enabled && "FREE"}
            {!enabled && "This item can only be purchased in stores"}
          </div>
          </div>
        </div>
    );
  } else if(
      !details.isInventoryRestricted 
      && fulfillmentDetails.isStoreAssortmentRestricted
      && !limitedStock 
      && !nearbyStoreLimitedStock
    ) {
    cardClasses.replace("card-enabled", "");
        return (
          <div className={cardClasses}>
            <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
              <div className="">
                <div className="pickup-in-store__icon pick-up-false"></div>
                <div className="tile-heading pickup-in-store__heading dai_tileHeading">
                  Store Pickup
                </div>
              </div>
              <div className="pickup-in-store__message-wrapper">
                <div className="tile-message pickup-in-store__message">
                  <div className="">
                   <div className="dai_tileMessage">
                      Not available for this item
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="u__center">
              <span className="u__text--success dai_tilePrice">
                <div className="dai_pickupTileMessage_checkNearby">
                  <a
                    href="#"
                    className="u__default-link store-inventory-finder-trigger"
                  >
                    Check Nearby Stores
                  </a>
                </div>
              </span>
            </div>
          </div>
        );
  } else {
    cardClasses.replace("card-enabled", "");
    return (
      <div className={cardClasses}>
        <div className="pickup-in-store__wrapper pickup-in-store__wrapper--disabled">
          <div className="">
            <div className="pickup-in-store__icon pick-up-false"></div>
            <div className="tile-heading pickup-in-store__heading dai_tileHeading">
              Store Pickup
            </div>
          </div>
          <div className="pickup-in-store__message-wrapper">
            <div className="tile-message pickup-in-store__message">
              <div className="">
                {!limitedStock && !nearbyStoreLimitedStock && (
                  <span className="dai_tileMessage">
                    0 in stock at {storeName}
                  </span>
                )}
                {(limitedStock || limitedStockInventoryRestricted || nearbyStoreLimitedStock) && (
                  <span className="dai_tileMessage">
                    <span className="warning_text">Limited stock at {nearbyStoreLimitedStock?nearbyStore.name:storeName} </span> 
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="u__center">
          <span className="u__text--success dai_tilePrice">
            <div className="dai_pickupTileMessage_checkNearby">
              <a
                href="#"
                className="u__default-link store-inventory-finder-trigger"
              >
                Check Nearby Stores
              </a>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default BopisOption;
